import {makeStyles} from "@mui/styles";

//Styling for the cards in the landing page
const useStyles = makeStyles({
    root: {
        width: '100%',
        maxWidth: '900px',
        height: 'auto',
        border: '1px solid #E0E0E0',
        borderRadius: '16px',
        backgroundColor: '#FFFFFF',
        padding: '1.5rem',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
        transition: 'all 0.3s ease',
        marginBottom: '1.5rem',
        '&:hover': {
            boxShadow: '0 8px 24px rgba(103, 80, 164, 0.12)',
            transform: 'translateY(-2px)',
            borderColor: '#E8DEF8',
        },
    },
    cardContent: {
        padding: '1rem 0',
    },
    cardTitle: {
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 700,
        fontSize: '1.25rem',
        color: '#1C1B1F',
        lineHeight: 1.4,
        marginBottom: '0.5rem',
        cursor: 'pointer',
        transition: 'color 0.2s ease',
        '&:hover': {
            color: '#6750A4',
        },
    },
    cardSubtitle: {
        fontFamily: 'Montserrat, sans-serif',
        fontSize: '0.95rem',
        color: '#49454F',
        lineHeight: 1.6,
    },
    cardMeta: {
        fontFamily: 'Roboto, sans-serif',
        fontSize: '0.85rem',
        color: '#79747E',
    },
    authorName: {
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 600,
        fontSize: '0.9rem',
        color: '#1C1B1F',
        cursor: 'pointer',
        '&:hover': {
            color: '#6750A4',
        },
    },
    authorRole: {
        fontFamily: 'Roboto, sans-serif',
        fontSize: '0.8rem',
        color: '#79747E',
    },
    thumbnail: {
        borderRadius: '12px',
        objectFit: 'cover',
        maxHeight: '200px',
        width: '100%',
    },
    tag: {
        display: 'inline-block',
        padding: '0.25rem 0.75rem',
        backgroundColor: '#E8DEF8',
        color: '#6750A4',
        borderRadius: '20px',
        fontSize: '0.75rem',
        fontWeight: 500,
        marginRight: '0.5rem',
    },
})

export default useStyles;
